module.exports = __webpack_public_path__ + "media/logos/QT-82a6124e.svg";